import { useEffect } from "react";
import { AppBox, AppTitle } from "../../../commons/components";
import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import MatchCommentaryAdd from "./components/commentary/MatchCommentaryAdd";
import {
  cleanUpSeasonMatchCommentaryList,
  fetchSeasonMatchCommentaryList,
} from "../../../redux/slices/football/admin/season/match/commentary/manage-season-match-commentary-list-slice";
import { StatusEnum } from "../../../commons/enums/status-enum";
import MatchCommentaryList from "./components/commentary/MatchCommentaryList";
import MatchPenaltyList from "./components/penalty/MatchPenaltyLIst";
import ability from "../../../casl/Can";
import { RolePolicyActionEnum } from "../../../commons/enums/role-policy-action.enum";
import { useParams } from "react-router";
import { ManageFootballTeam } from "../../../commons/models/football/admin/manage-football-team";
import { MatchStatusEnum } from "../../../commons/enums/match-status-enum";
import {ManageFootballCompetition} from "../../../commons/models/football/admin/manage-football-competition";

export default function MatchDetailManageCommentary() {
  const dispatch = useAppDispatch();
  const { teamId } = useParams();
  const { seasonMatchDetail, seasonMatchDetailStatus } = useAppSelector(
    (state) => state.footballManageSeasonMatchDetail
  );

  useEffect(() => {
    dispatch(cleanUpSeasonMatchCommentaryList());
    if (seasonMatchDetailStatus === StatusEnum.Succeeded && seasonMatchDetail.status !== MatchStatusEnum.Upcoming) {
      dispatch(
        fetchSeasonMatchCommentaryList({
          matchId: seasonMatchDetail.id,
          seasonId: seasonMatchDetail.season.id,
          urlParams: {
            hostTeamId: Number(teamId),
          },
        })
      );
    }
  }, [seasonMatchDetail]);

  useEffect(() => {
    return () => {
      dispatch(cleanUpSeasonMatchCommentaryList());
    };
  }, []);

  return (
    <AppBox mb="sm" flexDirection="column" gap="sm">
      {(ability.can(RolePolicyActionEnum.UPDATE, new ManageFootballCompetition(seasonMatchDetail.competition)) ||
        ability.can(RolePolicyActionEnum.UPDATE, new ManageFootballTeam({ id: Number(teamId) }))) && (
        <AppBox flexDirection="column" gap="xs">
          <AppTitle as="h5">Add Commentary</AppTitle>
          <MatchCommentaryAdd match={seasonMatchDetail} />
        </AppBox>
      )}

      {seasonMatchDetail.penalties.length > 0 && <MatchPenaltyList match={seasonMatchDetail} />}
      <MatchCommentaryList />
    </AppBox>
  );
}
